// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__cqU15","right":"Footer_right__2-T1B","buttons":"Footer_buttons__3iSEm"};